// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__3qqwB","footer":"Form_footer__2yX0k"};